import { DataTable } from '@ztechapps/webui.data-tools'
import { useBlogListContext } from './Context'
import { ListViewRow } from './ListViewRow'
import { ListViewHeader } from './ListViewHeader'
import { useBlogListFieldConfig } from './useBlogListFieldConfig'

const ListView = () => {
  const listResult = useBlogListContext()
  const fields = useBlogListFieldConfig()

  return (
    <DataTable
      name="blog_list_v1"
      listResult={listResult}
      fields={fields}
      head={ListViewHeader}
      row={ListViewRow}
      tableOptions={{ responsive: true }}
    />
  )
}

export { ListView }
